const gameStateKey = "gameState";

export const saveGameStateToLocalStorage = (gameState) => {
  localStorage.setItem(gameStateKey, JSON.stringify(gameState));
};

export const loadGameStateFromLocalStorage = () => {
  const state = localStorage.getItem(gameStateKey);
  return state ? JSON.parse(state) : null;
};

const gameStatKey = "gameStats";

export const saveStatsToLocalStorage = (gameStats) => {
  localStorage.setItem(gameStatKey, JSON.stringify(gameStats));
};

export const loadStatsFromLocalStorage = () => {
  const stats = localStorage.getItem(gameStatKey);
  return stats ? JSON.parse(stats) : null;
};

const surpriseSeenKey = "surpriseSeen";

export const hasSeenSurprise = () => {
  return localStorage.getItem(surpriseSeenKey) === "true";
};

export const markSurpriseSeen = () => {
  localStorage.setItem(surpriseSeenKey, "true");
};

export const clearSurpriseSeen = () => {
  localStorage.removeItem(surpriseSeenKey);
};

const surpriseAnswerKey = "surpriseAnswer";

export const loadSurpriseAnswer = () => {
  const value = localStorage.getItem(surpriseAnswerKey);
  return value === "yes" || value === "no" ? value : null;
};

export const saveSurpriseAnswer = (answer) => {
  localStorage.setItem(surpriseAnswerKey, answer);
};

export const clearSurpriseAnswer = () => {
  localStorage.removeItem(surpriseAnswerKey);
};
